module.exports = __webpack_public_path__ + "img/rise.5a5417e1.png";